// $(document).ready(function() {
// 	
// })

$('body').on('click', '.story-card-list__item', function() {
	$('#storiesDetails').find('.modal-body').html('');
	var $img = $(this).find('.stories-card__profile .img img').attr('src');
	var $rating = $(this).find('.star-rating img').attr('src');
	var $Info = $(this).find('.profile-disc').text();
	var $profileNmae = $(this).find('.profile-name').text();
	var $Score = $(this).find('.profile-score').text();
	
	var $storyDetail = '<div class="story-card-list__item slider-item"><div class="stories-card"> <div class="stories-card__profile"><div class="img"><img src='+$img+'></div></div><div class="stories-card__body"> <div class="star-rating"> <img src='+$rating+'></div><p class="mb-0 mt-3 pt-lg-1 text-16 text-888 profile-disc">'+$Info+'</p></div><div class="stories-card__footer"> <h4 class="profile-name text-21 fnt-600 text-f49 mb-1">'+$profileNmae+'</h4><span class="profile-score text--sm text-898">'+$Score+'</span></div></div>';

	$('#storiesDetails').find('.modal-body').append($storyDetail)

})